import { useQuery } from '@tanstack/react-query';
import apiClient from '@shared/lib/apiClient';
export const useTelegramConfig = () => useQuery({
    queryKey: ['telegram', 'config'],
    queryFn: async () => {
        const { data } = await apiClient.get('/telegram/config');
        return data;
    },
    staleTime: 1000 * 60,
    retry: 1,
});
